import { useAtomValue } from 'jotai'
import React from 'react'
import * as R from 'remeda'

import { useSurveyQueryQuestions } from '~/hooks/useSurveyQuery'
import { intersectionBy } from '~/utils'

import { tabulatedQuestionIdsAtom } from '../atoms'

export const useTabulatedQuestions = () => {
  const questions = useSurveyQueryQuestions()
  const tabulatedQuestionIds = useAtomValue(tabulatedQuestionIdsAtom)

  return React.useMemo(
    () =>
      intersectionBy(
        questions,
        tabulatedQuestionIds,
        R.prop('question_id'),
        R.identity(),
      ),
    [tabulatedQuestionIds, questions],
  )
}
